import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

class StudioDashboardDummy extends Component {
	render() {
		return <div className="insight-component-studio-dashboard"></div>;
	}
}

export default injectIntl(StudioDashboardDummy);
